import React, {
  Fragment,
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";

// Utils
import { _O } from "../../../modules/utils";

// UI
import { Container, DateLayer, openLayerFn } from "../../Layout";
import { SUBS, SubMenu } from "../Pmr";
import { TrtmtPeriodSetting } from "../PmrLayout";

// Provider
import styled from "styled-components";
import {
  AppContext,
  SET_ITEMSTATE,
  SET_PAGE_STATE,
  checkMobile,
} from "../../../components/AppProvider";
import { PostApi1706 } from "../../../modules/network/padoPost";
import { NativeAction } from "../../../modules/utils/HandleWs";

import {
  PeriodTypeChange,
  convertFormat,
  convertFormatString,
} from "../../../modules/utils/PeriodTypeChange";
import { requestGetNewPoint } from "../../../modules/utils/getNewPoint";
import IcCirclePlus from "../../../resources/images/icon/icon_component_01_circle_plus.png";
import { MapView } from "../../common/Modal/NaverMap";
import SkeletonPmr from "../../common/Skeleton/SkeletonPmr";
import {
  SocketCommand,
  socketManager,
} from "./../../../components/AppProvider";
import { AlertLayer } from "./../../../components/UI/Dialog";
import { PostApi1705 } from "./../../../modules/network/padoPost";
import { scrollLock } from "./../../../modules/utils/ScrollLock";
import { getCookie, setCookie } from "./../../../modules/utils/cookie";
import { closeLayerFn } from "./../../Layout";
import { DeleteLayer } from "./DeleteLayer";
import { SelectArea } from "./HospitalList";
import TreatmentDataComponent from "./TreatmentDataComponent";
import TreatmentDataManual from "./TreatmentDataManual";
import useTitle from "../../../modules/hooks/useTitle";

export default props => {
  useTitle("개인진료기록_진료자료");
  const { auth, userinfo, cfg, phonecfg, dispatch, pageState, itemState } =
    useContext(AppContext);

  const [msgCount, setMsgCount] = useState("");

  // 서브메뉴 활성화 값 (기본 0)
  const sub = SUBS[0];

  const [periodIndex, setPeriodIndex] = useState(0);
  const [startDate, setStartDate] = useState(
    convertFormat(PeriodTypeChange("year", 1), "yyyyMMdd")
  );
  const [endDate, setEndDate] = useState(
    convertFormat(PeriodTypeChange("year", 0), "yyyyMMdd")
  );

  const [selectStartDate, setSelectStartDate] = useState("");
  const [selectEndDate, setSelectEndDate] = useState("");

  const [hpCode, setHpCode] = useState("");
  const [hospitalName, setHospitalName] = useState("");
  const [hospitalList, setHospitalList] = useState("");

  const [isManualDisplay, setIsManualDisplay] = useState(false);

  // 병원전송 활성화 상태
  const [srchType, setSrchType] = useState(false);
  // 선택항목 array -> bottom 일괄처리를 위함
  const [selectDataArray, setSelectDataArray] = useState([]);

  // 지도 API 파라미터
  const [locationInfo, setLocationInfo] = useState({});

  // const [dataList, setDataList] = useState([]);
  const [dataList, setDataList] = useState(null);
  const [deleteData, setDeleteData] = useState({});

  const handleDate = (isStart, date) => {
    if (isStart === "1") {
      // setStartDate(date);
      setSelectStartDate(date);
    } else {
      // setEndDate(date);
      console.log("handleDate :: ", date);
      setSelectEndDate(date);
    }

    loadDataList();
  };

  const request1705 = () => {
    PostApi1705(
      userinfo,
      cfg,
      phonecfg,
      periodIndex != 3 ? startDate : selectStartDate,
      periodIndex != 3 ? endDate : selectEndDate,
      hospitalName === "병원 전체" ? "" : hospitalName,
      hpCode,
      srchType
    )
      .then(res => {
        if ((res.resultCode = "E000")) {
          setDataList(res.result);
          $("input:checkbox").prop("checked", false);
          setSelectDataArray([]);
          // setIsCheckAll(false);
        }
      })
      .catch(err => {
        console.log("SERVER ERR :: ", err);
      });
  };

  const loadDataList = () => {
    if ($(".delete-confirm-layer").css("display") === "block") {
      closeLayerFn($(".delete-confirm-layer"));
    }
    if (periodIndex == 3) {
      if ($(".pick-num1").val() != "" && $(".pick-num2").val() != "") {
        request1705();
      } else {
        setDataList([]);
      }
    } else {
      request1705();
    }
    requestGetNewPoint(userinfo, cfg, phonecfg, dispatch);
  };

  const loadHospitalList = () => {
    PostApi1706(
      userinfo,
      cfg,
      phonecfg,
      periodIndex != 3 ? startDate : selectStartDate,
      periodIndex != 3 ? endDate : selectEndDate
    )
      .then(res => {
        if ((res.resultCode = "E000")) {
          setHospitalList(res.result);
        }
      })
      .catch(err => {
        console.log("서버에러: ", err);
      });
  };

  const onManualOpenHandler = async () => {
    setIsManualDisplay(true);
    openLayerFn($("#addTrtmtData"));
    scrollLock();
  };

  useEffect(() => {
    // 최초 초기화
    dispatch({ type: SET_PAGE_STATE, data: { type: "all", state: 0 } });
  }, []);

  useEffect(() => {
    NativeAction(phonecfg, "statusColor", "#B2BEE6");
  }, [phonecfg.version]);

  useEffect(() => {
    if (periodIndex === 0) {
      setStartDate(convertFormat(PeriodTypeChange("year", 1), "yyyyMMdd"));
    } else if (periodIndex === 1) {
      setStartDate(convertFormat(PeriodTypeChange("year", 2), "yyyyMMdd"));
    } else if (periodIndex === 2) {
      setStartDate(convertFormat(PeriodTypeChange("year", 3), "yyyyMMdd"));
    } else {
      if (selectStartDate != "") {
        $("#dateFrom").val(convertFormatString(selectStartDate, "yyyy.MM.dd"));
        setStartDate(selectStartDate);
      } else {
        setStartDate("");
      }
      if (selectEndDate != "") {
        $("#dateTo").val(convertFormatString(selectEndDate, "yyyy.MM.dd"));
        setEndDate(selectEndDate);
      } else {
        setEndDate("");
      }
    }

    if (periodIndex != 4) {
      if (endDate != convertFormat(PeriodTypeChange("month", 0), "yyyyMMdd")) {
        setEndDate(convertFormat(PeriodTypeChange("month", 0), "yyyyMMdd"));
      }
    }
  }, [periodIndex]);

  useEffect(() => {
    // checkMsgCount(userinfo, cfg, phonecfg, "9", "00000000", "99999999", setMsgCount);

    loadDataList();
  }, [
    hpCode,
    hospitalName,
    srchType,
    selectStartDate,
    selectEndDate,
    startDate,
    endDate,
  ]);

  useEffect(() => {
    loadHospitalList();
  }, [startDate, endDate, selectStartDate, selectEndDate]);

  useEffect(() => {
    if (pageState.reload) {
      loadDataList();
      dispatch({
        type: SET_PAGE_STATE,
        data: { type: "reload", state: 0 },
      });
    }
  }, [hospitalName, periodIndex, srchType, dataList, pageState.reload]);

  useEffect(() => {
    if (itemState.reload) {
      if (itemState.data) {
        deleteReturnUpdate(itemState.data);
      }
      dispatch({
        type: SET_ITEMSTATE,
        data: { type: "COMPLETE" },
      });
    }
  }, [itemState.reload]);

  useLayoutEffect(() => {
    if (!getCookie("loginToDay")) {
      setCookie("loginToDay", false, 1);
    } else {
      setCookie("loginToDay", true, 1);
    }
  }, []);

  useEffect(() => {
    if (checkMobile() === "ANDROID") {
      // window.java.rcvFromWeb("wn111");
    } else if (
      checkMobile() === "IOS" &&
      parseInt(phonecfg.version.split(".")[2]) >= 25
    ) {
      webkit.messageHandlers.rcvFromWeb.postMessage({
        command: "wn111",
        data: "wn111",
      });
    }
  }, []);

  useEffect(() => {
    requestGetNewPoint(userinfo, cfg, phonecfg, dispatch);
  }, []);

  const deleteReturnUpdate = nativeReturnValue => {
    // command = download / masterKey1 = refKey, masterKey2= "", masterKey3 = ""
    // command = delete, deleteItem / masterKey1 = seqNo, masterKey2= "", masterKey3 = refKey
    const nativeReturnData = nativeReturnValue;
    let putDataList = dataList;

    if (nativeReturnData.command === "download") {
      putDataList = putDataList.map(data =>
        data.refKey == nativeReturnData.data[0].masterKey
          ? {
              ...data,
              fileCnt: nativeReturnData.data[0].fileCnt,
              dnCnt: nativeReturnData.data[0].fileCnt,
            }
          : data
      );
      setDataList(putDataList);
    } else {
      setDataList(
        putDataList.filter(
          e => e.seqNo != parseInt(nativeReturnData.data[0].masterKey)
        )
      );
    }

    if ($(".delete-confirm-layer").css("display") === "block") {
      closeLayerFn($(".delete-confirm-layer"));
    }
  };

  return (
    <Fragment>
      {/* <ScrollToTop /> */}
      <Container
        Title={sub.label}
        msgCount={msgCount}
        goToUrl="/"
        color="purple"
        bottom={
          srchType ? (
            <Bottom srchType={srchType} selectDataArray={selectDataArray} />
          ) : (
            ""
          )
        }>
        <div className="contents sub priv">
          {/* subTabMenu */}
          <SubMenu code={sub.code} />
          {/* /subTabMenu */}
          {/* 검색폼 */}
          <div className="pr-section">
            <div
              className="half-round-bgbox"
              style={{ margin: "0px", background: "#ffffff00" }}>
              <SubTitlle>기간설정</SubTitlle>
              {/* 기간 설정 */}
              <TrtmtPeriodSetting setPeriodIndex={setPeriodIndex} />
              {/* / 기간설정 */}

              <SelectArea
                hospitalList={hospitalList}
                setHospitalName={setHospitalName}
                setHpCode={setHpCode}
              />
            </div>
          </div>
          {/* / 검색폼 */}

          <div
            className="sub-contents"
            style={{ padding: "0px 20px 70px 20px" }}>
            <SubTitleBallon>
              <div>진료목록</div>
              {/* <div onClick={() => deleteReturnUpdate(JSON.stringify(testDataDelete))}>진료목록</div> */}
              {
                // 20230217 리스트가 존재할 경우에만 공유 정보 표시
                dataList != null &&
                  dataList.length > 0 &&
                  (!getCookie("loginToDay") ||
                    getCookie("loginToDay") === "false") && (
                    <div>
                      <div className="balloon_02">
                        <BallonText>
                          자료를 <b>병원에 공유</b>할 수 있습니다.
                        </BallonText>
                      </div>
                    </div>
                  )
              }
            </SubTitleBallon>
            {dataList != null ? (
              <TreatmentDataComponent
                srchType={srchType}
                setSrchType={setSrchType}
                setLocationInfo={setLocationInfo}
                setSelectDataArray={setSelectDataArray}
                startDate={startDate}
                endDate={endDate}
                dataList={dataList}
                setDeleteData={setDeleteData}
                periodIndex={periodIndex}
              />
            ) : (
              <SkeletonPmr />
            )}
            {!srchType && (
              <AddLayer>
                <Img src={IcCirclePlus} alt="" />
                <AddText onClick={onManualOpenHandler}>진료추가</AddText>
              </AddLayer>
            )}
          </div>
        </div>
      </Container>
      <TreatmentDataManual
        loadDataList={loadDataList}
        loadHospitalList={loadHospitalList}
      />
      <AlertLayer
        priv="priv"
        title=""
        msg="요청한 파일을 삭제하지 못했습니다."
      />
      <DateLayer handleDate={handleDate} />
      <DeleteLayer deleteData={deleteData} loadDataList={loadDataList} />

      {locationInfo && (
        <MapView
          selectHpNm={locationInfo.hsptNm}
          hpLat={locationInfo.latitude}
          hpLon={locationInfo.longitude}
          locationInfo={locationInfo}
          popupType="PF"
        />
      )}
    </Fragment>
  );
};

const Bottom = props => {
  // 신청한 자료 true =>  병원 전송, gray
  // 신청한 자료 false => 자료신청, black
  const { userinfo } = useContext(AppContext);
  const fn_uploadRequest = () => {
    let masterKeysParam = settingMasterKey();

    socketManager(SocketCommand.FILE_UPLOAD, undefined, {
      type: "upload",
      userToken: userinfo.userToken.toString(),
      masterKeys: masterKeysParam,
      bizType: "PR",
      bizName: "진료자료",
      bizDtlType: "",
      viewYN: "N",
      saveExtYN: "N",
      redirectURL: "cnntHspt/1",
      colorType: "PP",
      hsptSharYn: "Y",
      bizSubType: "0",
    });
  };

  const settingMasterKey = () => {
    let returnKey = [];
    props.selectDataArray.map(m =>
      returnKey.push({
        masterKey1: m.toString(),
        masterKey2: "",
        masterKey3: "",
      })
    );

    return returnKey;
  };

  return (
    <SectionDiv>
      <div
        className="two-btns-area"
        style={{ position: "relative", bottom: "100px" }}>
        <a
          onClick={() => {
            props.srchType ? fn_uploadRequest() : _O.Open("/pmr/proof/pay/45");
          }}
          className="btn-aftersave"
          style={{
            width: "100%",
            borderRadius: "8px",
            background: props.selectDataArray.length > 0 ? "black" : "#d0d0d0",
          }}>
          {props.srchType ? "병원 전송" : "자료 신청"}
        </a>
      </div>
    </SectionDiv>
  );
};

const dataListTest = [
  {
    dataType: "P",
    seqNo: 4927,
    hsptCd: "21051401",
    hsptNm: "미라벨검증_테스트",
    lat: "37.4812544",
    long: "127.0426538",
    zipCd: "08308",
    address1: "서울특별시",
    address2: "서초구",
    address3: "서울특별시 서초구 바우뫼로 222 3층 미라벨소프트",
    address4: "",
    mdltNm: "CT",
    studNm: "LIVER",
    studDt: "2024.01.25(목)",
    refKey: 8261,
    procStat: "03",
    fileCnt: 1,
    dnCnt: 1,
    newYn: "Y",
  },
  {
    dataType: "P",
    seqNo: 4924,
    hsptCd: "21051401",
    hsptNm: "미라벨검증_테스트",
    lat: "37.4812544",
    long: "127.0426538",
    zipCd: "08308",
    address1: "서울특별시",
    address2: "서초구",
    address3: "서울특별시 서초구 바우뫼로 222 3층 미라벨소프트",
    address4: "",
    mdltNm: "ES",
    studNm: "위내시경",
    studDt: "2024.01.16(화)",
    refKey: 8259,
    procStat: "03",
    fileCnt: 2,
    dnCnt: 2,
    newYn: "N",
  },
];

/* css */
const SubTitlle = styled.div`
  width: 49px;
  height: 15px;
  left: 23px;
  padding-left: 3px;
  padding-bottom: 11px;

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  /* identical to box height */

  color: #000000;
  display: flex;
`;

const SubTitleBallon = styled.div`
  width: 49px;
  left: 23px;
  padding-left: 3px;
  line-height: 30px;
  // padding-bottom: 11px; /*11px;*/

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  /* identical to box height */

  color: #000000;
  display: flex;
`;

const BallonText = styled.span`
  padding-left: 10px;
  padding-right: 7.75px;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
`;

const AddLayer = styled.div`
  width: 100%;
  line-height: 18px;

  display: inline-block;
  text-align: center;
  flex-direction: column;
`;

const AddText = styled.div`
  font-size: 14px;
  margin-left: 8px;

  display: inline-block;
  text-align: center;
`;

const Img = styled.img`
  display: inline-block;
  box-sizing: border-box;
  vertical-align: middle;
  padding-bottom: 3px;
`;

const SectionDiv = styled.div`
  padding-top: 32px;
  padding-left: 20px;
  padding-right: 20px;
`;
